import { useMutation } from '@tanstack/react-query';
import { ASSIST_API } from 'services/assist-api/axios';
import type { AssistQuery } from 'services/assist-api/query';
import { AssistQueryClient } from 'services/assist-api/query-client';

export type CreateGroupUsersVariables = { customerUsers: number[]; group: number };

export const useCreateGroupUsers: AssistQuery.UseMutations<undefined, CreateGroupUsersVariables> = (
  options
) =>
  useMutation(
    ({ customerUsers, group }: CreateGroupUsersVariables) =>
      Promise.allSettled(
        customerUsers.map((customerUser) =>
          ASSIST_API.post('groups-users', {
            data: {
              type: 'GroupsUsers',
              relationships: {
                user: {
                  data: {
                    id: `/api/v2/customers-users/${customerUser}`,
                    type: 'CustomersUsers'
                  }
                },
                group: {
                  data: {
                    id: `/api/v2/groups/${group}`,
                    type: 'Group'
                  }
                }
              }
            }
          })
        )
      ),
    {
      ...options,
      onSettled: (...args) => {
        AssistQueryClient.invalidateQueries(['groups']);
        AssistQueryClient.invalidateQueries(['customers-users']);
        if (options?.onSettled) {
          options.onSettled(...args);
        }
      }
    }
  );
